<div id="menu">
  <div class="logo">
    <img src="./assets/logo-menu.svg">

    <span>FIELD SERVICE</span>
  </div>

  <a [routerLink]="['/panel/dashboard']" class="icn-dashboard" routerLinkActive="active" *ngIf="userMenu.painelDeControle">Painel de Controle</a>

  <a [routerLink]="['/panel/service-order']" class="icn-service-order" routerLinkActive="active" *ngIf="userMenu.ordensDeServico">Ordens de Serviço</a>

  <a [routerLink]="['/panel/service-order-management']" class="icn-service-order-management" routerLinkActive="active" *ngIf="userMenu.aprovarReprovarOs">Aprovar/Reprovar OS</a>

  <a [routerLink]="['/panel/invoice']" class="icn-invoice" routerLinkActive="active" *ngIf="userMenu.notasFiscais">Notas Fiscais</a>

  <a [routerLink]="['/panel/reports']" class="icn-reports" routerLinkActive="active" *ngIf="userMenu.relatorios">Relatórios</a>

  <a [routerLink]="['/panel/equipments']" class="icn-equipments" routerLinkActive="active" *ngIf="userMenu.equipamentos">Equipamentos</a>

  <a [routerLink]="['/panel/services']" class="icn-services" routerLinkActive="active" *ngIf="userMenu.valorPorServico">Valor por Serviço</a>
  
  <a [routerLink]="['/panel/service-providers']" class="icn-service-providers" routerLinkActive="active" *ngIf="userMenu.prestadorDeServico">Prestador de Serviço</a>

  <a [routerLink]="['/panel/supervisor']" class="icn-supervisor" routerLinkActive="active" *ngIf="userMenu.supervisor">Supervisor</a>
</div>
